import RunInfoHelper from '@/utils/wb-js-tookit/run-info-helper'

const _iosAppStoreLink = 'https://apps.apple.com/hk/app/id1601778743'

let iframe

// egg: winbull://article_details?id={id}
function callApp(path = '') {
  const uri = path

  if (RunInfoHelper.isAndroidDevice()) {
    // 判断是否是在屏蔽唤起协议的app打开
    if (['weixin', 'weibo', 'qq'].includes(RunInfoHelper.openIn())) {
      // 如在微信中则不进行唤起app操作
      return
    } else {
      iframe = document.createElement('iframe')
      iframe.setAttribute('src', uri)
      iframe.style.display = 'none'
      document.body.appendChild(iframe)
    }
  }
  if (RunInfoHelper.isAppleDevice()) {
    // 【ID1001915】暂时屏蔽ios打开下载页唤起app操作
    // ios设备，现在是不做操作，app已经接入了Universal Link
  }
}

class AppDowloadHelper {
  // 下载安卓apk
  static downloadAndroidPackage(href, name = 'winbull') {
    // 创建隐藏的可下载链接
    var eleLink = document.createElement('a')
    eleLink.setAttribute('href', href)
    eleLink.setAttribute('download', name)
    eleLink.style.display = 'none'
    // 触发点击
    document.body.appendChild(eleLink)
    eleLink.click()
    // 然后移除
    document.body.removeChild(eleLink)
  }

  static linkClick(href) {
    // 创建隐藏的可下载链接
    var eleLink = document.createElement('a')
    eleLink.setAttribute('href', href)
    eleLink.style.display = 'none'
    // 触发点击
    document.body.appendChild(eleLink)
    eleLink.click()
    // 然后移除
    document.body.removeChild(eleLink)
  }

  // ios打开商店，android下载apk
  static openStoreOrDownloadApp({ browserNotAllow, apkUrl = '' }) {
    let link = ''
    // 如在微信中打开，则通知用户使用手机浏览器打开
    if (['weixin', 'weibo', 'qq'].includes(RunInfoHelper.openIn())) {
      if (browserNotAllow) {
        browserNotAllow()
      }
      return
    }

    if (RunInfoHelper.isAppleDevice()) {
      // 如果是苹果设备则打开appStore
      link = _iosAppStoreLink
      window.location = link
    } else {
      // 其它的如安卓、PC都进行apk下载
      if (!apkUrl) {
        return
      }
      AppDowloadHelper.downloadAndroidPackage(apkUrl)
    }
  }

  static openURL(fn, url) {
    if (['weixin', 'weibo', 'qq'].includes(RunInfoHelper.openIn())) {
      if (fn) {
        fn()
      }
      return
    }
    AppDowloadHelper.linkClick(url)
  }
}

export { callApp, AppDowloadHelper }
